export default __webpack_public_path__ + "static/media/loss-analysis-step-4.56fcbe69.gif";